export const LISTE_COMMANDE_ACHAT = {
  title: 'Liste des commandes bailleur',
  breadcrumb: {
    liste: 'Liste commandes bailleur',
  },
  tab: {
    code: 'Commande n°',
    date: 'Date',
    bailleur: 'Bailleur',
    etat: 'Etat',
    montantHt: 'Montant HT',
    montantTtc: 'Montant TTC',
  },
  filtre: {
    bailleur: 'Bailleur (s)',
    etat: 'Etat(s)',
    periode: 'Date Commande',
    agence: 'Agence(s)',
    error: {
      date: 'La date de début est plus grande que la date de fin',
    },
  },
};

export const DETAIL_COMMANDE_ACHAT_BAILLEUR = {
  title: 'Détail commande bailleur n°{code}',
  referenceFournisseur: 'Référence fournisseur: {referenceFournisseur}',
  breadcrumb: {
    listeCommandeBailleur: 'Liste commandes bailleur',
    detailCommandeBailleur: 'Détail d\'une commande bailleur',
  },
  typeFacture: 'Facture',
  multiTypeFacture: 'Factures',
  sousTypeAvoir: 'Avoir',
  sousTypeAcompte: 'Acompte',
  error: {
    regelementMustBeCancel: 'Vous devez annuler les règlements avant d’annuler votre acompte',
  },
  buttons: {
    solderManuellement: 'Solder manuellement',
    annulerSoldeManuel: 'Annuler le solde manuel',
  },
  popups: {
    confirmationSolderManuellement: 'Voulez-vous solder manuellement cette facture ?',
    confirmationCopieFacture: 'La duplication va vous rediriger vers une page de création de facture pré-remplie avec les informations de la facture n°{code}',
    confirmationAnnulerSoldeManuel: 'Voulez-vous annuler le solde manuel de cette facture ?',
  },
  anchor: {
    title: 'Commande',
    echeancierFacturation: 'Echéancier de facturation',
    piecesJointes: 'Pièces jointes',
  },
  clients: {
    clientExonerationTva: 'Client exonéré de TVA',
    tvaIntra: 'TVA intracommunautaire : {tva}',
    prospect: 'Prospect',
    siretClient: 'Siret : {siret}',
    siretDefault: 'Siret : nc.',
  },
  achatVenteInterne: {
    title: 'Factures d\'achat',
    action: {
      generation: 'Re-générer factures d\'achat et de vente interne',
      allGeneration: 'Re-générer toutes les factures d\'achat et de vente interne',
    },
    tab: {
      fournisseur: 'Fournisseur',
      code: 'Facture achat',
      etat: 'Etat',
      montantHt: 'Montant HT',
      referenceFournisseur: 'Facture vente interne',
      status: 'Statut',
    },
    warning: {
      generation: 'Etes-vous sûr de vouloir re-génerer le(s) facture(s) d\'achat et de vente interne ?',
    },
    success: {
      generation: 'Re-génération réalisé avec succès',
    },
    achat: {
      title: 'Détail de la facture d\'achat n°: {code}',
      titleAvoir: 'Détail de l\'avoir d\'achat n°: {code}',
      breadcrumb: {
        title: 'Détail facture achat',
        titleAvoir: 'Détail avoir achat',
      },
      tab: {
        detail: 'Détail',
        ecritureCompta: 'Ecriture comptable',
      },
      steps: {
        infoGenerales: 'Facture',
        echeancier: 'Echéancier de paiement',
        pj: 'Pièces jointes',
        factureVente: 'Facture de vente',
        avoirLie: 'Avoir(s) lié(s)',
      },
      factureVente: {
        title: 'Facture de vente',
        factureVente: 'Facture de vente :',
      },
    },
    vente: {
      title: 'Détail de la facture vente interne n°: {code}',
      titleAvoir: 'Détail de l\'avoir de vente interne n°: {code}',
      breadcrumb: {
        title: 'Détail facture vente interne',
        titleAvoir: 'Détail avoir interne',
        liste: 'Liste des factures',
      },
      tab: {
        detail: 'Détail',
        ecritureCompta: 'Ecriture comptable',
      },
      steps: {
        infoGenerales: 'Commande',
        echeancier: 'Echéancier de facturaction',
        pj: 'Pièces jointes',
      },
    },
  },
};

export const EDITION_COMMANDE_ACHAT_BAILLEUR = {
  title: 'Modifier la commande bailleur n°{code}',
  breadcrumb: {
    liste: 'Liste commandes bailleur',
    edit: 'Modifier commande bailleur',
  },
  bailleur: {
    title: 'Bailleur',
    adresse: 'Adresse commerciale',
  },
  tabs: {
    quotation: 'Informations générales',
    echeancierCommandeAchatBailleur: 'Echéancier',
  },
  infoGenerales: {
    title: 'Informations générales',
    theme: 'Theme',
    date: 'Date Signature',
  },
  infoProduit: {
    title: 'Informations produits',
  },
  infoCommentaire: {
    title: 'Commentaires',
    commentaireInterne: 'Commentaires interne',
  },
  messages: {
    success: {
      edit: 'Commande achat bailleur modifiée avec succès.',
    },
    error: {
      oneProduct: 'La commande achat bailleur doit contenir au moins une ligne avec un produit',
    },
  },
};
